import React, { useCallback } from 'react';

import { Button } from 'ui-components/components/button';
import { NotificationService, NOTIFICATION_DURATIONS, NOTIFICATION_TYPE_SUCCESS } from 'ui-components/services/notification-service';

import { FormattedMessage } from 'react-intl';
import messages from '../../../../onboard/steps/label-step/messages';
import { SelectLabelLayoutModal } from '../../../../../components/modals/select-label-layout-modal';
import { useModal } from '../../../../../hooks/use-modal';
import { useTrackWorkflow, WorkflowSteps } from '../../../../../tracking/use-workflow-tracking';
import { EventSourceStrings, Workflows } from '../../../../../tracking/tracking-constants';

/**
 * @param {object} props
 * @param {() => void} props.onActionClicked - callback called when the action button is clicked
 * @returns {JSX.Element}
 */
export const LabelLayoutButton = ({ onActionClicked }) => {
  const { open, close, isOpen } = useModal();
  const trackLabelLayoutSelection = useTrackWorkflow(Workflows.LABEL_LAYOUT_SELECTION_FLOW);
  const onOpen = useCallback(() => {
    open();
    onActionClicked();
    trackLabelLayoutSelection(WorkflowSteps.START, {
      source: EventSourceStrings.HOME_PAGE_FEED,
    });
  }, [open, onActionClicked, trackLabelLayoutSelection]);

  const onSuccess = useCallback(() => {
    NotificationService.showNotification({
      notificationType: NOTIFICATION_TYPE_SUCCESS,
      title: <FormattedMessage {...messages.saveSuccessMessage} />,
      content: '',
      duration: NOTIFICATION_DURATIONS.MEDIUM,
    });
  }, []);
  return (
    <div>
      <Button onClick={onOpen} theme='tertiary'>
        <FormattedMessage {...messages.labelLayoutButton} />
      </Button>
      {isOpen && <SelectLabelLayoutModal onClose={close} onSuccess={onSuccess} />}
    </div>
  );
};
